<template>
  <div class="case_banner">
    <div>
      <img src="../../assets/case.jpg" />
      <div class="wenan">
        <div class="wen_title">解决方案</div>
        <div class="wen_content">
          以满足客户流程数字化管控+智慧物联场景建设需求为核心 <br />
          帮助制造企业实现供应敏捷化、制造柔性化、产品个性化、决策智能化
        </div>
      </div>
    </div>
  </div>
  <div class="contaier cases">
    <div class="inner">
      <div class="content_title">
        <div class="flex title1">
          <div class="flex-item left">
            <span class="line_"></span>
          </div>
          <div class="text">
            <span>解决</span>
            <span class="red">方案</span>
          </div>
          <div class="flex-item right">
            <span class="line_"></span>
          </div>
        </div>
        <div class="title2">CASE</div>
      </div>
      <div class="case_detail">
        <div class="case_heard">
          <el-upload
            v-if="this.isZ"
            :limit="1"
            :before-upload="beforeUpload"
            action="attachment/localUpload"
            accept=".png,.jpg,.jpeg,.gif"
          >
            <img v-if="this.caseVo.url" :src="this.caseVo.url" style="width: 1500px" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <img
            v-if="!this.isZ && this.caseVo.url"
            :src="this.caseVo.url"
            @click="toDp()"
          />
          <!-- <img :src="this.caseVo.url" /> -->
          <div
            v-if="this.isZ || this.caseVo.title || this.caseVo.content"
            class="case_jianjie"
          >
            <div class="jj_title">
              <el-input
                v-if="this.isZ"
                v-model="this.caseVo.title"
                placeholder="请输入标题"
              />
              <span v-else>{{ this.caseVo.title }}</span>
            </div>
            <div class="jj_content">
              <el-input
                v-if="this.isZ"
                v-model="this.caseVo.content"
                type="textarea"
                :rows="5"
                placeholder="请输入简介"
              />
              <span v-else> {{ this.caseVo.content }}</span>
            </div>
          </div>
        </div>
        <div class="case_cj">
          <div class="cj_herder">
            <div class="cj_title">场景痛点</div>
            <div class="cj_con">深挖场景痛点，精准打造针对性场景解决方案</div>
          </div>
          <div class="cj_concent">
            <div :key="this.cjndkey" class="flex cj_for">
              <div
                v-for="item in this.caseVo.yuans"
                :key="item.id"
                :style="{
                  width:
                    inner_width /
                      (this.isZ ? this.caseVo.yuanTotal + 1 : this.caseVo.yuanTotal) +
                    'px',
                }"
                class="cj_box"
              >
                <div
                  class="cj_item"
                  :style="{
                    width:
                      inner_width /
                        (this.isZ ? this.caseVo.yuanTotal + 1 : this.caseVo.yuanTotal) -
                      15 +
                      'px',
                  }"
                >
                  <el-popover placement="bottom" width="180" trigger="hover">
                    <div style="width: 100%">{{ item.str }}</div>
                    <template #reference>
                      <div
                        v-html="sanitizedHtml(item.content)"
                        class="case_item_data"
                      ></div>
                    </template>
                  </el-popover>
                  <el-button
                    v-if="this.isZ"
                    type="danger"
                    style="
                      position: absolute;
                      top: 0%;
                      right: 0%;
                      width: 5px;
                      height: 5px;
                    "
                    @click="deletcCjtd(item.id)"
                    circle
                  ></el-button>
                </div>
              </div>

              <div
                v-if="this.isZ"
                :style="{
                  width:
                    (inner_width - 10) /
                      (this.isZ ? this.caseVo.yuanTotal + 1 : this.caseVo.yuanTotal) +
                    'px',
                }"
                class="cj_box"
              >
                <div class="cj_item" @click="openCjPage()">
                  <img class="cj_addBtn" src="../../assets/addbig.png" />
                </div>
              </div>
            </div>
          </div>
          <el-dialog v-model="cjVisible" :title="this.cjTitle" width="500px">
            <el-input
              v-model="this.cjnd"
              type="textarea"
              :readonly="this.isend"
              :rows="3"
              placeholder="请输入"
            />
            <div v-html="sanitizedHtml(this.painItem.content)" class="colorSpan"></div>
            <template #footer>
              <span class="dialog-footer">
                <el-button v-if="!this.isend" @click="doEnd()">完成书写</el-button>
                <el-button v-if="this.isend" @click="reEnd()">重新书写</el-button>
                <el-color-picker
                  v-if="this.isend"
                  class="colorSelect"
                  v-model="colorVar"
                ></el-color-picker>
                <el-button v-if="this.isend" @click="doColor()">渲染</el-button>
                <el-button @click="cjVisible = false">取消</el-button>
                <el-button v-if="this.isend" type="primary" @click="submitCjtd()"
                  >确认提交</el-button
                >
              </span>
            </template>
          </el-dialog>
        </div>
        <div class="case_fa">
          <div class="fa_herder">
            <div class="fa_title">解决方案</div>
            <div class="fa_con">借助甚好解决方案，实现企业数字化转型</div>
          </div>
          <div class="fa_concent">
            <div class="fa_for" v-for="item in this.schemes" :key="item.id">
              <div class="fa_title_min">{{ item.title }}</div>
              <div v-for="str in item.descriptionList" :key="str" class="fa_description">
                {{ str }}
              </div>
              <div v-if="!item.descriptionList" class="fa_description">
                {{ item.description }}
              </div>
              <div class="demo-image__lazy" v-if="item.urls">
                <div
                  v-for="(url, index) in item.urls"
                  :key="index"
                  class="image-container"
                >
                  <el-image :src="url" lazy></el-image>
                </div>
              </div>
              <el-button
                v-if="this.isZ"
                type="primary"
                @click="openAddScheme(item)"
                round
                style="width: 100%; margin-top: 10px; margin-bottom: 10px"
                >查看详情</el-button
              >
            </div>
            <el-button
              v-if="this.isZ"
              type="primary"
              @click="openAddScheme()"
              style="width: 100%; margin-top: 10px; margin-bottom: 10px"
              round
              >添加案例</el-button
            >
            <el-dialog v-model="addVisible" width="60%" title="案例详情">
              <div class="fa_title_min">
                <el-input v-model="this.schemeItem.title" placeholder="请输入标题" />
              </div>
              <div>
                <el-input
                  v-model="this.schemeItem.description"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入相关描述"
                />
              </div>
              <el-upload
                v-if="this.isZ"
                :key="filekey"
                list-type="picture-card"
                :before-upload="beforeUpload"
                :file-list="
                  this.schemeItem.attachmentVoList ? this.schemeItem.attachmentVoList : []
                "
                action="file/path"
                accept=".png,.jpg,.jpeg,.gif"
                :on-preview="handlePictureCardPreview"
                :before-remove="beforeRemove"
                :on-remove="hoverRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <template #footer>
                <span class="dialog-footer">
                  <el-button v-if="this.hasScheme" class="delete" @click="deleteScheme"
                    >删除</el-button
                  >
                  <el-button @click="addVisible = false">返回</el-button>
                  <el-button type="primary" @click="submitfa()">确认提交</el-button>
                </span>
              </template>
            </el-dialog>
            <el-dialog v-model="dialogVisible" width="60%">
              <img width="100%" :src="this.dialogImageUrl" alt="" />
            </el-dialog>
          </div>
        </div>
        <div class="case_gs">
          <div class="gs_herder">
            <div class="gs_title">改善提升</div>
          </div>
          <div class="gs_content">
            <div :key="this.gstskey" class="gs_for">
              <ul class="gs_ul">
                <li v-for="item in this.caseVo.gsts" :key="item.id" class="gs_li">
                  {{ item.content }}
                  <el-button
                    v-if="this.isZ"
                    type="danger"
                    style="
                      position: absolute;
                      top: 36%;
                      right: 5%;
                      width: 5px;
                      height: 5px;
                    "
                    @click="deletcGsts(item.id)"
                    circle
                  ></el-button>
                </li>
              </ul>
              <el-button
                v-if="this.isZ"
                type="primary"
                @click="openGsts()"
                style="width: 100%; margin-top: 10px; margin-bottom: 10px"
                round
                >改善提升描述</el-button
              >
            </div>
          </div>
          <el-dialog v-model="gstsVisible" title="改善提升描述" width="500px">
            <el-input
              v-model="this.gstsItem.content"
              type="textarea"
              :rows="3"
              placeholder="请输入"
            />
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="gstsVisible = false">取消</el-button>
                <el-button type="primary" @click="submitcGsts()">确认提交</el-button>
              </span>
            </template>
          </el-dialog>
        </div>
        <div class="case_us">
          <div class="us_herder">
            <div class="us_title">请专业顾问为您解答或演示</div>
          </div>
          <div class="us_content">
            <el-input
              placeholder="请输入11位手机号码"
              v-model="this.photo"
              class="us_phone"
              style="width: 56%; margin: auto; font-size: 22px"
            >
            </el-input>
            <el-button
              @click="openUs"
              type="primary"
              style="height: 68px; width: 140px; font-size: 22px"
              >联系我们</el-button
            >
          </div>
          <el-dialog v-model="usVisible" width="50%" center>
            <div class="mes">
              <div class="us_mes_title">在线咨询</div>
              <div class="mes-from">
                <el-form :model="messageFrom" :rules="rules" ref="messageFrom">
                  <el-form-item
                    label="名称："
                    prop="name"
                    label-width="120px"
                    style="height: 50px; font-size: 18px"
                  >
                    <el-input
                      v-model="messageFrom.name"
                      placeholder="您的名字"
                      style="height: 50px; font-size: 18px"
                    />
                  </el-form-item>
                  <el-form-item
                    label="联系电话："
                    prop="contact"
                    label-width="120px"
                    style="height: 50px; font-size: 18px"
                  >
                    <el-input
                      v-model="messageFrom.contact"
                      placeholder="您的电话"
                      style="height: 50px; font-size: 18px"
                    />
                  </el-form-item>
                  <el-form-item
                    label="邮箱："
                    prop="email"
                    label-width="120px"
                    style="height: 50px; font-size: 18px"
                  >
                    <el-input
                      v-model="messageFrom.email"
                      placeholder="您的邮箱"
                      style="height: 50px; font-size: 18px"
                    />
                  </el-form-item>
                  <el-form-item
                    label="公司名称："
                    prop="company"
                    label-width="120px"
                    style="height: 50px; font-size: 18px"
                  >
                    <el-input
                      v-model="messageFrom.company"
                      placeholder="您的公司"
                      style="height: 50px; font-size: 18px"
                    />
                  </el-form-item>
                  <el-form-item
                    label="地址："
                    prop="site"
                    label-width="120px"
                    style="height: 50px; font-size: 18px"
                  >
                    <el-input
                      v-model="messageFrom.site"
                      placeholder="若需要咨询购置产品，可以填上地址"
                      style="height: 50px; font-size: 18px"
                    />
                  </el-form-item>
                  <el-form-item label="资讯内容：" prop="content" label-width="120px">
                    <el-input
                      v-model="messageFrom.content"
                      type="textarea"
                      :rows="5"
                      placeholder="您想咨询内容咨询内容"
                      style="font-size: 18px"
                    />
                  </el-form-item>
                </el-form>
                <div class="mes-footer">
                  <el-button
                    type="primary"
                    @click="submitMessage('messageFrom')"
                    style="height: 50px; width: 84%; font-size: 20px"
                    >提交留言</el-button
                  >
                </div>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
      <div class="footerBtn" v-if="this.islook">
        <span class="dialog-footer">
          <el-button @click="nolook()">取消预览</el-button>
        </span>
      </div>
      <div class="footerBtn" v-if="this.isZ">
        <span class="dialog-footer">
          <el-button @click="look()">预览</el-button>
          <el-button @click="beforeDeleteCase()">移除</el-button>
          <el-button @click="fhdelete()">返回</el-button>
          <el-button type="primary" @click="subCase()">提交</el-button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { ref } from "vue";
import DOMPurify from "dompurify";
import { ElMessage } from "element-plus";
import { v4 as uuid4v } from "uuid";
import axios from "axios";
import SparkMD5 from "spark-md5";
export default {
  data() {
    return {
      messageFrom: {
        name: "",
        contact: "",
        email: "",
        company: "",
        content: "",
        site: "",
      },
      rules: {
        name: [{ required: true, message: "请输入您名称", trigger: "blur" }],
        contact: [
          { required: true, message: "请输入您的联系方式", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的号码", trigger: "blur" },
        ],
        email: [{ type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }],
        company: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        content: [{ required: true, message: "请输入咨询内容", trigger: "blur" }],
      },
      iszc: false,
      hasScheme: false,
      filekey: false,
      isend: false,
      islook: false,
      dialogVisible: false,
      addVisible: false,
      gstsVisible: false,
      usVisible: false,
      cjVisible: false,
      cjndkey: false,
      gstskey: false,
      doAddZc: false,
      store: useStore(),
      isZ: false,
      caseVo: {
        title: "",
        content: "",
        url: "",
        oldFileId: "",
        fileId: "",
        oldPath: "",
        fileStatus: 2,
        yuans: [],
        gsts: [],
        yuanTotal: 4,
      },
      schemes: [],
      schemeItem: {
        id: "",
        title: "",
        description: "",
        sno: 0,
        attachmentVoList: [],
        urls: [],
      },
      painItem: {
        id: "",
        content: "",
        type: 1,
      },
      gstsItem: {
        id: "",
        content: "",
        type: 2,
      },
      inner_width: 820,
      cjnd: "",
      colorVar: ref("#409EFF"),
      cjTitle: "痛点描述--请先书写完成再去划重点上颜色",
      photo: "",
      id: "",
      attachNo: "",
      finner: 0,
      isKK: true,
    };
  },
  mounted() {
    const host = window.location.host;
    this.isKK = host.includes("fjkkauto");
    const user = this.store.state.userInfo;
    this.isZ = user ? (user.permission ? user.permission == 0 : false) : false;
    this.inner_width = document.querySelector(".cj_for").offsetWidth;
    this.id = this.$route.query.id;
    if (this.id) {
      this.getDetail();
    } else {
      if (this.isZ) {
        this.attachNo = uuid4v();
        this.schemeNo = uuid4v();
      }
    }
  },
  methods: {
    toDp() {
      console.log("------", this.caseVo);
      if (this.caseVo && this.caseVo.title && this.caseVo.title.includes("水务案例1")) {
        window.open(
          "https://cloud.iotbus.net/shareQRcode/?share=JDsgdY6Eu4D7snw6eik1&type=project&title=污水处理车间"
        );
      }
    },
    addZc() {
      if (this.doAddZc) {
        return;
      }
      axios
        .post("/case/addt")
        .then((response) => {
          if (response.data.code === 200) {
            ElMessage.success("案例已经暂存空白模板，如不暂存请点击下方返回按钮！");
            this.caseId = response.data.data;
            this.iszc = true;
            this.doAddZc = true;
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("数据获取失败：", error);
        });
    },
    fhdelete() {
      if (this.iszc) {
        this.$confirm("是否暂存案例?", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/CasePage");
          })
          .catch(() => {
            this.deleteCase();
            this.$router.push("/CasePage");
          });
      } else {
        this.$router.push("/CasePage");
      }
    },

    beforeDeleteCase() {
      this.$confirm("此操作将移除案例，是否确认移除?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteCase();
          this.$router.push("/CasePage");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消移除案例,",
          });
        });
    },
    deleteCase() {
      const caseDto = {
        id: this.iszc ? this.caseId : this.id,
        schemeNo: this.schemeNo,
        attachmentId: this.caseVo.fileId,
        path: this.caseVo.url,
      };
      axios
        .post("/case/delete", caseDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        })
        .then(() => {})
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("产品上架失败", error);
        });
    },
    subCase() {
      if (!this.caseVo.title && !this.caseVo.content) {
        ElMessage.error("没有写入场景标题及相关内容描述，无法提交！");
      } else {
        const caseDto = {
          id: this.iszc ? this.caseId : this.id,
          title: this.caseVo.title,
          description: this.caseVo.content,
          attachmentId: this.caseVo.fileId,
          attachNo: this.attachNo,
          path: this.caseVo.url,
          schemeNo: this.schemeNo,
        };
        axios
          .post("/case/save", caseDto, {
            Headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          })
          .then((response) => {
            if (response.data.code == 200) {
              this.$router.push("/CasePage");
            }
          })
          .catch((error) => {
            // 处理请求错误
            ElMessage.error("请求失败，请检查网络或接口地址");
            console.error("案例添加失败", error);
          });
      }
    },
    getDetail() {
      axios
        .get("/case/get", {
          params: { Id: this.id },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            ElMessage.success("数据获取成功");
            this.caseVo.title = response.data.data.title;
            this.caseVo.content = response.data.data.description;
            this.caseVo.fileId = response.data.data.attachmentId;
            this.attachNo = response.data.data.attachNo;
            this.schemeNo = response.data.data.schemeDtos
              ? response.data.data.schemeDtos[0].attachNo
              : uuid4v();
            this.caseVo.url = response.data.data.path;
            this.schemes = response.data.data.schemeDtos;
            this.caseVo.yuans = response.data.data.painDtos1;
            this.caseVo.gsts = response.data.data.painDtos2;
            this.caseVo.yuanTotal = response.data.data.painDtos1.length;
          } else {
            ElMessage.error("数据获取失败：" + response.data.description);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("数据获取失败：", error);
        });
    },
    openCjPage() {
      this.painItem = {
        id: "",
        content: "",
        type: 1,
      };
      this.cjnd = "";
      this.isend = false;
      this.cjVisible = true;
      if (!this.id) {
        this.addZc();
      }
    },
    openUs() {
      if (this.photo.match(/^1[3456789]\d{9}$/)) {
        (this.messageFrom = {
          name: "",
          contact: this.photo,
          email: "",
          company: "",
          content: "",
          site: "",
        }),
          (this.usVisible = true);
      } else {
        ElMessage.error("请输入正确的手机号码!");
      }
    },
    openGsts() {
      this.gstsItem = {
        id: "",
        content: "",
        type: 2,
      };
      this.gstsVisible = true;
      if (!this.id) {
        this.addZc();
      }
    },
    doColor() {
      const text = window.getSelection().toString(); // 获取选中的文本
      const textColor = `<span style="color : ${this.colorVar};">${text}</span>`;
      this.painItem.content = this.painItem.content
        ? this.painItem.content.replace(text, textColor)
        : this.cjnd.replace(text, textColor);
    },
    sanitizedHtml(textColor) {
      return DOMPurify.sanitize(textColor, {
        ALLOWED_TAGS: ["span"],
        ALLOWED_ATTR: ["style"],
      });
    },
    doEnd() {
      this.isend = true;
      this.cjTitle = "痛点描述--仅划重点，如需修改文本请按重新书写按钮";
    },
    reEnd() {
      this.isend = false;
      this.cjTitle = "痛点描述--请先书写完成再去划重点上颜色";
      this.painItem.content = "";
    },
    look() {
      this.islook = true;
      this.isZ = false;
    },
    nolook() {
      this.islook = false;
      this.isZ = true;
    },
    deletcCjtd(id) {
      this.$confirm("此操作将移除该场景痛点描述, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios
            .get("/pain/delete", {
              params: { Id: id },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                this.queryPain(1);
                this.cjndkey = !this.cjndkey;
              } else {
                ElMessage.error("痛点移除失败" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("痛点移除失败", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消移除该产品痛点",
          });
        });
    },
    deletcGsts(id) {
      this.$confirm("此操作将移除该案例改善提升描述, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios
            .get("/pain/delete", {
              params: { Id: id },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                this.queryPain(2);
                this.gstskey = !this.gstskey;
              } else {
                ElMessage.error("改善提升描述移除失败" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("改善提升描述移除失败", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消移除该产品痛点",
          });
        });
    },
    submitcGsts() {
      if (!this.gstsItem.content) {
        ElMessage.error("没有写入内容，无法提交！");
      } else {
        const painDto = {
          caseId: this.iszc ? this.caseId : this.id,
          content: this.gstsItem.content,
          type: 2,
        };
        axios
          .post("/pain/save", painDto, {
            Headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          })
          .then((response) => {
            if (response.data.code == 200) {
              this.gstsVisible = false;
              this.queryPain(2);
              this.gstskey = !this.gstskey;
            }
          })
          .catch((error) => {
            // 处理请求错误
            ElMessage.error("请求失败，请检查网络或接口地址");
            console.error("改善提升描述添加失败", error);
          });
      }
    },
    submitCjtd() {
      if (!this.painItem.content && !this.cjnd) {
        ElMessage.error("没有写入内容，无法提交！");
      } else {
        const painDto = {
          caseId: this.iszc ? this.caseId : this.id,
          content: this.painItem.content ? this.painItem.content : this.cjnd,
          type: 1,
        };
        axios
          .post("/pain/save", painDto, {
            Headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          })
          .then((response) => {
            if (response.data.code == 200) {
              this.cjVisible = false;
              this.queryPain(1);
              this.cjndkey = !this.cjndkey;
            }
          })
          .catch((error) => {
            // 处理请求错误
            ElMessage.error("请求失败，请检查网络或接口地址");
            console.error("痛点添加失败", error);
          });
      }
    },
    queryPain(type) {
      const painDto = {
        caseId: this.iszc ? this.caseId : this.id,
        type: type,
      };
      axios
        .post("/pain/query", painDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        })
        .then((response) => {
          if (response.data.code == 200) {
            if (type == 1) {
              this.caseVo.yuans = response.data.data;
            } else if (type == 2) {
              this.caseVo.gsts = response.data.data;
            }
          }
          if (response.data.code == 1010) {
            if (type == 1) {
              this.caseVo.yuans = response.data.data;
            } else if (type == 2) {
              this.caseVo.gsts = response.data.data;
            }
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("痛点添加失败", error);
        });
    },
    submitfa() {
      const schemeDto = {
        id: this.schemeItem.id,
        caseId: this.iszc ? this.caseId : this.id,
        title: this.schemeItem.title,
        description: this.schemeItem.description,
        attachNo: this.schemeNo,
        sno: this.schemeItem.sno,
      };
      axios
        .post("/scheme/save", schemeDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.addVisible = false;
            this.queryScheme();
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("产品上架失败", error);
        });
    },
    queryScheme() {
      const schemeDto = {
        caseId: this.iszc ? this.caseId : this.id,
        attachNo: this.schemeNo,
      };
      axios
        .post("/scheme/query", schemeDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.schemes = response.data.data;
          } else {
            this.schemes = [];
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("产品上架失败", error);
        });
    },
    deleteScheme() {
      this.$confirm("此操作将移除该小方案, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const schemeDto = {
            id: this.schemeItem.id,
            caseId: this.iszc ? this.caseId : this.id,
            title: this.schemeItem.title,
            description: this.schemeItem.description,
            attachNo: this.schemeNo,
            sno: this.schemeItem.sno,
          };
          axios
            .post("/scheme/delete", schemeDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            })
            .then((response) => {
              if (response.data.code == 200) {
                this.addVisible = false;
                this.queryScheme();
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("小案例移除失败", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消移除该小方案",
          });
        });
    },
    openAddScheme(item) {
      this.addVisible = true;
      if (!this.id) {
        this.addZc();
      }
      if (item) {
        this.schemeItem = item;
        this.hasScheme = true;
      } else {
        (this.schemeItem = {
          id: "",
          title: "",
          description: "",
          sno: this.schemes ? this.schemes.length : 0,
          attachmentVoList: [],
          urls: [],
        }),
          (this.hasScheme = false);
      }
    },
    async beforeUpload(file) {
      if (!file) {
        this.$message.error("文件丢失取消上传");
        return false;
      } else if (file.size / 1024 / 1024 > 50) {
        this.$message.error("文件不能大雨50M");
        return false;
      }
      try {
        var fileReader = new FileReader();
        //获取文件二进制数据
        fileReader.readAsArrayBuffer(file);
        const spark = new SparkMD5.ArrayBuffer();
        fileReader.onload = async (e) => {
          spark.append(e.target.result);
          this.MD5 = spark.end();
          this.localUpload(file, this.MD5);
        };
      } catch (error) {
        console.error("计算MD5值有误：", error);
        return false;
      }
      return false;
    },
    //上传文件到本地服务器
    localUpload(file, MD5) {
      const fileType = file.name.split(".")[1];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("md5", MD5);
      formData.append("category", "case");
      formData.append("size", file.size);
      formData.append("originalName", file.name);
      formData.append("type", fileType);
      formData.append("method", 0);
      formData.append("attachNo", this.addVisible ? this.schemeNo : this.attachNo);
      if (!this.addVisible) {
        formData.append("oldId", this.caseVo.oldFileId);
        formData.append("oldPath", this.caseVo.oldPath);
        formData.append("id", this.caseVo.fileId);
      }
      formData.append("finner", this.schemeItem.sno);
      formData.append("status", this.caseVo.fileStatus);
      formData.append("subcategory", this.addVisible ? "scheme" : "");
      // 提交数据到接口
      axios
        .post("/attachment/localUpload", formData, {
          Headers: {
            "Content-Type": "multipart/form-data",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            ElMessage.success("提交成功");
            if (!this.addVisible) {
              this.caseVo.fileId = response.data.data.id;
              this.caseVo.oldFileId = response.data.data.id;
              this.caseVo.url = response.data.data.path;
              this.caseVo.oldPath = response.data.data.path;
              this.caseVo.fileStatus = 2;
            } else {
              this.schemeItem.attachmentVoList = this.schemeItem.attachmentVoList
                ? this.schemeItem.attachmentVoList
                : [];
              this.schemeItem.urls = this.schemeItem.urls ? this.schemeItem.urls : [];
              this.schemeItem.attachmentVoList.push({
                id: response.data.data.id,
                name: response.data.data.originalName,
                subcategory: response.data.data.subcategory,
                url: response.data.data.path,
                sno: response.data.data.sno,
              });
              this.schemeItem.urls.push(response.data.data.path);
              this.filekey = !this.filekey;
            }
          } else {
            ElMessage.error("提交失败：" + response.data.message);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("提交失败：", error);
        });
    },
    async beforeRemove(file) {
      if (file.status && file.status == "ready") {
        return false;
      }
      return await this.$confirm("此操作将移除图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {
          return false;
        });
    },
    handlePictureCardPreview(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
    },
    hoverRemove(file) {
      axios
        .get("/attachment/delete", {
          params: {
            id: file.id,
            url: file.url,
            subcategory: file.subcategory,
            no: this.schemeNo,
            sno: file.sno,
            finner: file.finner,
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结
          if (response.data.code === 200) {
            (this.schemeItem.attachmentVoList = []), (this.schemeItem.urls = []);
            response.data.data.forEach((vo) => {
              this.schemeItem.attachmentVoList.push({
                id: vo.id,
                name: vo.originalName,
                url: vo.path,
                sno: vo.sno,
                subcategory: vo.subcategory,
              });
              this.schemeItem.urls.push(vo.path);
            });
            this.filekey = !this.filekey;
            ElMessage.success("附件移除成功");
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("文件移除失败", error);
        });
    },
    submitMessage(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          // 提交数据到接口
          const messageDto = {
            type: 0,
            name: this.messageFrom.name,
            contact: this.messageFrom.contact,
            email: this.messageFrom.email,
            company: this.messageFrom.company,
            site: this.messageFrom.site,
            content: this.messageFrom.content,
            usCompanyType: this.isKK ? 1 : 2,
          };
          // 提交数据到接口
          axios
            .post("/message/add", messageDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                ElMessage.success("留言成功");
                this.messageChange();
                this.usVisible = false;
              } else {
                ElMessage.error("留言失败" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("留言失败", error);
            });
        } else {
          ElMessage.error("请填写所有必填项");
          return false;
        }
      });
    },
    messageChange() {
      this.messageFrom = {
        name: "",
        contact: "",
        email: "",
        company: "",
        content: "",
        site: "",
      };
    },
  },
};
</script>

<style>
.cases {
  padding-top: 20px;
  /* background: rgba(32, 188, 255, 0.1); */
}
.case_banner {
  width: 100%;
  display: flex;
  flex-direction: column; /* 使子元素垂直排列 */
  /* align-items: center; 水平居中 */
  justify-content: center; /* 垂直居中 */
  position: relative; /* 对于绝对定位的文本 */
  height: 460px;
}
.case_banner .img {
  width: 100%; /* 或者你希望的宽度 */
  /* height: auto; 保持图片比例 */
  height: 460px;
}

.wenan {
  position: absolute; /* 或者使用相对定位 */
  top: 25%; /* 根据需要调整距离图片顶部的距离 */
  left: 46%; /* 根据需要调整距离图片左侧的距离 */
  /* width: 100%; 与图片宽度相同 */
  color: white; /* 文字颜色 */
  /* text-align: center; 文字居中 */
  z-index: 10; /* 确保文字在图片上方 */
}
.wen_title {
  font-size: 56px;
  font-weight: 1000;
  font-style: oblique;
  letter-spacing: 12px; /*文本间隔 */
  padding-bottom: 30px;
}
.wen_content {
  font-size: 22px;
  letter-spacing: 3px; /*文本间隔 */
}
.content_title {
  margin-bottom: 10px;
}
.case_detail {
  width: 100%;
  padding-bottom: 50px;
}
.case_heard {
  /* height: 800px; */
  display: flex;
  flex-direction: column; /* 使子元素垂直排列 */
  align-items: center; /*水平居中*/
  justify-content: center; /* 垂直居中 */
  position: relative; /* 对于绝对定位的文本 */
}
.case_heard {
  width: 100%;
}
.case_heard i {
  background: rgba(0, 98, 255, 0.08);
  padding-top: 80px;
  width: 1500px;
  height: 480px;
  border-radius: 3px;
  border: 2px solid #efefef;
}
.case_heard img {
  width: 100%;
  height: 700px;
}
.case_jianjie {
  position: absolute; /* 或者使用相对定位 */
  bottom: 0%; /* 根据需要调整距离图片底部部的距离 */
  left: 0%; /* 根据需要调整距离图片左侧的距离 */
  width: 100%; /* 与图片宽度相同 */
  color: white; /* 文字颜色 */
  z-index: 10; /* 确保文字在图片上方 */
  background: rgba(0, 0, 0, 0.4);
  padding-top: 20px;
  padding-bottom: 30px;
}
.jj_title {
  width: 80%;
  font-size: 45px;
  font-weight: 1000;
  letter-spacing: 8px; /*文本间隔 */
  padding-bottom: 10px;
  margin: auto;
}
.jj_content {
  width: 80%;
  font-size: 24px;
  letter-spacing: 3px; /*文本间隔 */
  margin: auto;
}
.case_cj {
  margin-top: 20px;
  margin-bottom: 60px;
}
.cj_herder {
  text-align: center;
  width: 100%;
}
.cj_title {
  font-size: 34px;
  font-weight: 800;
  letter-spacing: 8px; /*文本间隔 */
  color: #29299d;
}
.cj_con {
  font-size: 24px;
  font-weight: 500;
  color: #5a5a92c1;
}
.cj_concent {
  width: 100%;
  height: 230px;
  margin-top: 20px;
  border-radius: 1px;
  border: 1px solid #efefef;
  background: rgba(0, 94, 255, 0.08);
  padding-top: 10px;
  padding-bottom: 10px;
}
.cj_for {
  width: 80%;
  margin: auto;
  height: 100%;
  align-items: center;
}
.cj_box {
  margin-left: 10px;
  margin-right: 10px;
  height: 90%;
}
.cj_item {
  position: relative; /* 设置父元素为相对定位 */
  border-radius: 1px;
  border: 2px solid #efefef;
  box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.1);
  height: 100%;
  width: 100%;
}
.case_item_data {
  color: #707070;
  font-size: 160%;
  font-weight: 520;
  width: 100%;
  margin: auto;
  padding-top: 15px;
  height: 90%;
  overflow: hidden;
  /* white-space; */
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.cj_addBtn {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.colorSelect {
  padding-right: 20px;
  padding-left: 20px;
}
.colorSpan {
  margin-top: 10px;
  margin-left: 5px;
}

.case_fa {
  margin-top: 60px;
}
.fa_herder {
  text-align: center;
  width: 100%;
}
.fa_title {
  font-size: 34px;
  font-weight: 800;
  letter-spacing: 8px; /*文本间隔 */
  color: #2356cfe0;
}
.fa_con {
  font-size: 24px;
  font-weight: 500;
  color: #5a5a92c1;
}

.case_gs {
  margin-top: 60px;
}
.gs_herder {
  text-align: center;
  width: 100%;
}
.gs_title {
  font-size: 34px;
  font-weight: 800;
  letter-spacing: 8px; /*文本间隔 */
  color: #2356cfe0;
}

.case_us {
  margin-top: 60px;
  background: rgba(0, 98, 255, 0.08);
  padding-top: 80px;
  width: 100%;
  height: 280px;
  border-radius: 3px;
  border: 2px solid #efefef;
}
.us_herder {
  text-align: center;
  width: 100%;
}
.us_title {
  font-size: 34px;
  font-weight: 800;
  letter-spacing: 8px; /*文本间隔 */
  color: #2356cfe0;
}
.us_content {
  margin-top: 50px;
  width: 100%;
  text-align: center;
}
.us_phone {
  height: 70px;
}
.mes {
  text-align: center;
  width: 98%;
  padding: 10px;
}
.us_mes_title {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 8px; /*文本间隔 */
  color: #2356cfe0;
  padding-bottom: 30px;
}
.gs_for {
  margin-top: 20px;
  background: rgba(0, 98, 255, 0.08);
  width: 100%;
  border-radius: 3px;
  border: 2px solid #efefef;
  margin-bottom: 20px;
  color: #707070;
  font-weight: 600;
  font-size: 180%;
  width: 100%;
}
.gs_ul {
  padding-left: 150px;
}
.gs_li {
  position: relative; /* 设置父元素为相对定位 */
  height: 60px;
  line-height: 60px;
}
.fa_for {
  margin-top: 20px;
  padding-top: 20px;
  background: rgba(0, 98, 255, 0.08);
  width: 100%;
  border-radius: 3px;
  border: 2px solid #efefef;
  margin-bottom: 20px;
  width: 100%;
  text-align: center;
}
.fa_title_min {
  /* text-align: center; */
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 8px; /*文本间隔 */
  color: #2356cfe0;
  padding-bottom: 20px;
}
.fa_description {
  padding-left: 100px;
  text-align: left;
  color: #707070;
  font-size: 160%;
  font-weight: 520;
  width: 100%;
  margin: auto;
  padding-bottom: 20px;
}
.fa_for img {
  width: 900px;
  display: block;
  margin: auto;
  object-fit: contain;
}
</style>
